export default [
  [55, 142, 189, 255],
  [225, 109, 0, 255],
  [167, 87, 163, 255],
  [205, 0, 0, 255],
]
